import { render, staticRenderFns } from "./ReferralWeeklyCommissions.vue?vue&type=template&id=8c0e8a66&"
import script from "./ReferralWeeklyCommissions.vue?vue&type=script&lang=js&"
export * from "./ReferralWeeklyCommissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports